// @ts-ignore
import TaskStatusesCollection from './task-statuses-collection'
import {ModelInterface} from "../../data-structures/collection"
import TaskTypeSettings from "./task-type-settings"

const debug = false
// const debug = "TaskType"

export default class TaskType implements ModelInterface {

    id              : string
    companyId       : string
    name            : string
    icon            : string
    statuses        : TaskStatusesCollection | null
    isDeleted       : boolean
    sortPosition    : number

    templateTitle   : string
    templateMessage : string

    customFields    : ID[]

    settings        : TaskTypeSettings
    type            : string

    constructor(data:any) {
        this.id                 = data['id']
        this.companyId          = data['companyId']
        this.name               = data['name']
        this.icon               = data['icon']
        this.statuses           = data['statuses'] ? TaskStatusesCollection.initFromJson(data['statuses']) : null
        this.isDeleted          = _.get(data, 'isDeleted', false)
        this.sortPosition       = data['sortPosition']

        this.templateTitle      = data['templateTitle']
        this.templateMessage    = data['templateMessage']
        this.customFields       = _.get(data, 'customFields', [])
        this.settings           = new TaskTypeSettings(data['settings'])
        this.type               = this.settings.isGeneric ? "Default" : ""

        debug && console.log(debug, 'constructor', this, data)
    }

    public goToSettings() {
        gd.navigation.goTo('settings/task-types/'+this.id)
    }

    get missingCustomFields():ID[]|null {
        const missingCustomFieldIds : ID[] = []

        _.map(this.customFields, (customFieldId:ID)=>{
            if (!gd.session.customFields.get(customFieldId)) {
                missingCustomFieldIds.push(customFieldId)
            }
        })

        if (_.isEmpty(missingCustomFieldIds)) return null

        return missingCustomFieldIds
    }

    public hasSystemField(fieldId:string):boolean {
        return !this.settings.hiddenFields?.includes(fieldId)
    }

    public get hasFieldAssignee():boolean {
        return this.hasSystemField(gd.fields.task.assignedToUserId.fieldId)
    }

    public get hasFieldAR():boolean {
        return this.hasSystemField(gd.fields.task.actionRequiredUserId.fieldId)
    }

    clone() {
        return new TaskType(this.toJSON());
    }

    toJSON() {
        return {
            id              : this.id,
            companyId       : this.companyId,
            name            : this.name,
            icon            : this.icon,
            statuses        : this.statuses ? this.statuses.toJSON() : null,
            isDeleted       : this.isDeleted,
            sortPosition    : this.sortPosition,

            templateTitle   : this.templateTitle,
            templateMessage : this.templateMessage,

            customFields    : this.customFields,

            settings        : this.settings.toJSON(),
        }
    }
}